/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListContributorsForACar500Response,
  Me401Response,
} from '../models/index';
import {
    ListContributorsForACar500ResponseFromJSON,
    ListContributorsForACar500ResponseToJSON,
    Me401ResponseFromJSON,
    Me401ResponseToJSON,
} from '../models/index';

export interface ApproveAContributionRequestRequest {
    carId: number;
    userId: number;
}

export interface DenyAContributionRequestRequest {
    carId: number;
    userId: number;
}

export interface ListContributorsForACarRequest {
    carId: number;
}

export interface RequestToContributeToACarRequest {
    carId: number;
}

/**
 * CarContributorsApi - interface
 * 
 * @export
 * @interface CarContributorsApiInterface
 */
export interface CarContributorsApiInterface {
    /**
     * Owner-only. Flips the target user\'s record to `approved` and sends a `ContributionApproved` notification to that user. If the user is not already in the contributors list, 404.
     * @summary Approve a contribution request
     * @param {number} carId The ID of the car.
     * @param {number} userId The ID of the user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarContributorsApiInterface
     */
    approveAContributionRequestRaw(requestParameters: ApproveAContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Owner-only. Flips the target user\'s record to `approved` and sends a `ContributionApproved` notification to that user. If the user is not already in the contributors list, 404.
     * Approve a contribution request
     */
    approveAContributionRequest(requestParameters: ApproveAContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Owner-only. Flips the target user\'s record to `denied` and sends a `ContributionDenied` notification. Also used to revoke an existing approval — the effect is the same.
     * @summary Deny a contribution request
     * @param {number} carId The ID of the car.
     * @param {number} userId The ID of the user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarContributorsApiInterface
     */
    denyAContributionRequestRaw(requestParameters: DenyAContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Owner-only. Flips the target user\'s record to `denied` and sends a `ContributionDenied` notification. Also used to revoke an existing approval — the effect is the same.
     * Deny a contribution request
     */
    denyAContributionRequest(requestParameters: DenyAContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Owner-only: returns every contribution record (pending, approved, denied) for the given car. Non-owners receive a 404 to avoid leaking the list.
     * @summary List contributors for a car
     * @param {number} carId The ID of the car.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarContributorsApiInterface
     */
    listContributorsForACarRaw(requestParameters: ListContributorsForACarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Owner-only: returns every contribution record (pending, approved, denied) for the given car. Non-owners receive a 404 to avoid leaking the list.
     * List contributors for a car
     */
    listContributorsForACar(requestParameters: ListContributorsForACarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Returns the authenticated user\'s contribution records across all cars and statuses. Supports `filter[status]=approved|pending|denied`. Includes the related car and its owner.
     * @summary My contributions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarContributorsApiInterface
     */
    myContributionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Returns the authenticated user\'s contribution records across all cars and statuses. Supports `filter[status]=approved|pending|denied`. Includes the related car and its owner.
     * My contributions
     */
    myContributions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates a pending contribution request from the authenticated user for the given car. If a previous request exists (denied or pending), it is reset to pending. Owners cannot request to contribute to their own car. The car owner receives a `ContributionRequested` notification.
     * @summary Request to contribute to a car
     * @param {number} carId The ID of the car.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarContributorsApiInterface
     */
    requestToContributeToACarRaw(requestParameters: RequestToContributeToACarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Creates a pending contribution request from the authenticated user for the given car. If a previous request exists (denied or pending), it is reset to pending. Owners cannot request to contribute to their own car. The car owner receives a `ContributionRequested` notification.
     * Request to contribute to a car
     */
    requestToContributeToACar(requestParameters: RequestToContributeToACarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class CarContributorsApi extends runtime.BaseAPI implements CarContributorsApiInterface {

    /**
     * Owner-only. Flips the target user\'s record to `approved` and sends a `ContributionApproved` notification to that user. If the user is not already in the contributors list, 404.
     * Approve a contribution request
     */
    async approveAContributionRequestRaw(requestParameters: ApproveAContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['carId'] == null) {
            throw new runtime.RequiredError(
                'carId',
                'Required parameter "carId" was null or undefined when calling approveAContributionRequest().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling approveAContributionRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/cars/{car_id}/contributors/{user_id}/approve`;
        urlPath = urlPath.replace(`{${"car_id"}}`, encodeURIComponent(String(requestParameters['carId'])));
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Owner-only. Flips the target user\'s record to `approved` and sends a `ContributionApproved` notification to that user. If the user is not already in the contributors list, 404.
     * Approve a contribution request
     */
    async approveAContributionRequest(requestParameters: ApproveAContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.approveAContributionRequestRaw(requestParameters, initOverrides);
    }

    /**
     * Owner-only. Flips the target user\'s record to `denied` and sends a `ContributionDenied` notification. Also used to revoke an existing approval — the effect is the same.
     * Deny a contribution request
     */
    async denyAContributionRequestRaw(requestParameters: DenyAContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['carId'] == null) {
            throw new runtime.RequiredError(
                'carId',
                'Required parameter "carId" was null or undefined when calling denyAContributionRequest().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling denyAContributionRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/cars/{car_id}/contributors/{user_id}/deny`;
        urlPath = urlPath.replace(`{${"car_id"}}`, encodeURIComponent(String(requestParameters['carId'])));
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Owner-only. Flips the target user\'s record to `denied` and sends a `ContributionDenied` notification. Also used to revoke an existing approval — the effect is the same.
     * Deny a contribution request
     */
    async denyAContributionRequest(requestParameters: DenyAContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.denyAContributionRequestRaw(requestParameters, initOverrides);
    }

    /**
     * Owner-only: returns every contribution record (pending, approved, denied) for the given car. Non-owners receive a 404 to avoid leaking the list.
     * List contributors for a car
     */
    async listContributorsForACarRaw(requestParameters: ListContributorsForACarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['carId'] == null) {
            throw new runtime.RequiredError(
                'carId',
                'Required parameter "carId" was null or undefined when calling listContributorsForACar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/cars/{car_id}/contributors`;
        urlPath = urlPath.replace(`{${"car_id"}}`, encodeURIComponent(String(requestParameters['carId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Owner-only: returns every contribution record (pending, approved, denied) for the given car. Non-owners receive a 404 to avoid leaking the list.
     * List contributors for a car
     */
    async listContributorsForACar(requestParameters: ListContributorsForACarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.listContributorsForACarRaw(requestParameters, initOverrides);
    }

    /**
     * Returns the authenticated user\'s contribution records across all cars and statuses. Supports `filter[status]=approved|pending|denied`. Includes the related car and its owner.
     * My contributions
     */
    async myContributionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/contributions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Returns the authenticated user\'s contribution records across all cars and statuses. Supports `filter[status]=approved|pending|denied`. Includes the related car and its owner.
     * My contributions
     */
    async myContributions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.myContributionsRaw(initOverrides);
    }

    /**
     * Creates a pending contribution request from the authenticated user for the given car. If a previous request exists (denied or pending), it is reset to pending. Owners cannot request to contribute to their own car. The car owner receives a `ContributionRequested` notification.
     * Request to contribute to a car
     */
    async requestToContributeToACarRaw(requestParameters: RequestToContributeToACarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['carId'] == null) {
            throw new runtime.RequiredError(
                'carId',
                'Required parameter "carId" was null or undefined when calling requestToContributeToACar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/cars/{car_id}/contributors`;
        urlPath = urlPath.replace(`{${"car_id"}}`, encodeURIComponent(String(requestParameters['carId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a pending contribution request from the authenticated user for the given car. If a previous request exists (denied or pending), it is reset to pending. Owners cannot request to contribute to their own car. The car owner receives a `ContributionRequested` notification.
     * Request to contribute to a car
     */
    async requestToContributeToACar(requestParameters: RequestToContributeToACarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.requestToContributeToACarRaw(requestParameters, initOverrides);
    }

}
